import { pluralizeWithCount } from "@common/helpers/string";

/**
 * The client is deliberately one-way: the codebase can't safely move a
 * connection's data between clients, so an assigned row's Client cell offers
 * no affordance and says why instead. The entity stays editable, since moving
 * within the same client keeps the data where it is.
 */
export const NO_REASSIGNMENT_TOOLTIP =
    "To keep data secure, changing clients isn't possible. Please manually add the connection to the new client.";

export const CLIENT_EDITABLE_UNTIL_ENTITY_HELPER =
    "You can change the client until you confirm the entity.";

/**
 * Each modal serves a single row and a bulk selection, so the title carries the
 * scope: a row is self-evident from the row you clicked, a selection is not.
 */
export const clientAssignmentModalTitle = (accountCount: number): string =>
    accountCount === 1
        ? "Select client"
        : `Select client for ${pluralizeWithCount("account", accountCount)}`;

export const entityAssignmentModalTitle = (accountCount: number): string =>
    accountCount === 1
        ? "Select entity"
        : `Select entity for ${pluralizeWithCount("account", accountCount)}`;
